// eslint-disable-next-line no-restricted-imports
import { ThemeProvider } from '@emotion/react';
import { ReeferThemeProvider } from '@iheartjane/reefer';
import type { CustomThemeConfig } from '@iheartjane/reefer';
import type { PropsWithChildren } from 'react';

import { defaultTheme } from '@jane/kiosk/util';

type KioskThemeProviderProps = PropsWithChildren<{
  theme?: CustomThemeConfig;
  themeId?: string;
}>;

export const KioskThemeProvider = ({
  theme = defaultTheme,
  themeId,
  children,
}: KioskThemeProviderProps) => (
  <ReeferThemeProvider
    legacy={true}
    renderProvider={(theme, children) => (
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    )}
    theme={theme}
    themeId={themeId}
  >
    {children}
  </ReeferThemeProvider>
);
